// Vuex
import store from '@/store.js';
// i18n
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

import consts from "@/consts.js";
import Request from './request';

async function imports(file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/materials/new-import", data);
}

async function fetch(data) {
    return Request('get', "api/materials", data);
}

async function fetchNoCancel(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/materials", data, false, false, true);
}

async function exports(data) {// 导出报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/materials/export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function newExports(data) {// 新导出报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/materials/new-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function fetchOne(id, data) {// 获取单个
    return Request('get', "api/materials/" + id, data);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/materials", data);
}

async function fetchAllNoPaging(data) {
    if (!data) data = {};
    // data.limit = consts.limitAll; //获取全部
    return Request('post', "api/materials/select", Object.assign({},data,{
        itemsPerPage: consts.limitAll,
        limit: consts.limitAll,
    }));
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    data.fieldFilter = ["id","material_code","material_name","Standard.name","category_code","MaterialCategory.name","public_flg"]; // 仅筛选少许必要字段
    return Request('get', "api/materials/select", data, false, false, true);
}

async function save(id, data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (data.standard && data.standard.standard_details) {
        data.standard.standard_details = data.standard.standard_details.map(
            (standard_detail) => {
                standard_detail.default_flg = standard_detail.default_flg ? 1 : 0;
                return standard_detail;
            }
        )
    }
    if (data.material_category)
        data.category_code = data.material_category.code;

    if (id)
        return Request('patch', "api/materials/edit?id=" + id, data);
    else
        return Request('post', "api/materials/add", data);
}

async function del(id) {// 删除数据
    return Request('delete', "api/materials/" + id);
}

async function getPinyin(string) {
    return Request('get', "api/materials/get-pinyin-initials/" + string, "", true);
}

async function fetchGroups() {
    return Request('get', "api/materials/get-filed-selects", {field_name: 'material_group'});
}

async function fetchFiledSelects(data) {
    return Request('get', "api/materials/get-filed-selects", data);
}

async function bindDefaultSupplier(data) {
    return Request('patch', "api/materials/bind-default-supplier" , data);
}

async function importsImg(file) {// 批量导入图片
    var data = new FormData();
    data.append("zip", file);
    return Request('post', "api/materials/import-material-img-zip", data);
}

async function importsAlbum(file) {// 商品多图集导入
    var data = new FormData();
    data.append("zip", file);
    return Request('post', "api/materials/import-album-zip", data);
}

async function imagesUpload(files) {// 批量上传图片
    if (Array.isArray(files)) {
        var data = new FormData();
        files.forEach(file => {
          data.append("images[]", file);
        })
        return Request('post', "api/materials/post-images" ,data);
    } else {
        return new Promise((resolve) => resolve());
    }
}

async function getEditDefaultUnits(id) {
    return Request('get', "api/materials/getEditDefaultUnits/" + id);
}

async function editDefaultUnitPreview(data) {
    return Request('post', "api/materials/editDefaultUnit", data);
}
async function getStockMaterials(id) {// 获取库存
    return Request('get', "api/materials/get-stock-materials/" + id);
}

async function combineFormulaImport(file) {// 组合配方导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/Materials/combineFormulaImport", data);
}

async function splitFormulaImport(file) {// 拆零配方导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/Materials/splitFormulaImport", data);
}

async function checkEditAndDelete(id) {// 商品校验
    return Request('post', "api/materials/check-edit-and-delete/" + id);
}

async function syncThirdMaterial() {
    return Request('get', "api/materials/sync-third-material/");
}

async function checkEditCostUnit(id) {// 商品成本单位校验
    return Request('post', "api/materials/check-edit-cost-unit/" + id);
}

async function batchUpdateMaterialField(data) {
    return Request('post', "api/materials/batchUpdateMaterialField",data);
}

async function syncHuaManLouMaterials() {
    return Request('get', "api/materials/sync-hua-man-lou-materials/");
}

async function newAddImportExcel(file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/materials/newAddImport", data);
}

async function newEditImportExcel(file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/materials/newEditImport", data);
}

export default {
    imports,
    fetch, exports,newExports,
    fetchOne,
    fetchAll,
    fetchAllNoPaging,
    fetchAllForSelect,
    save,
    del,
    getPinyin,
    fetchGroups,
    fetchFiledSelects,
    bindDefaultSupplier,
    fetchNoCancel,
    importsImg,
    importsAlbum,
    imagesUpload,
    getEditDefaultUnits,
    editDefaultUnitPreview,
    getStockMaterials,
    combineFormulaImport,
    splitFormulaImport,
    checkEditAndDelete,
    syncThirdMaterial,
    checkEditCostUnit,
    batchUpdateMaterialField,
    syncHuaManLouMaterials,
    newAddImportExcel,
    newEditImportExcel,
};